export default __webpack_public_path__ + "static/media/pantry2-before2-480w.024ca1d3.avif";